import { Route, Routes } from "react-router-dom";
import DashboardV3 from "../../pages/V3/DashboardV3/DashboardV3";
import { RequireAuth } from "../../utils/auth/auth";

export default function DashboardV3Router() {
  return (
    <Routes>
      <Route
        path=""
        element={
          <RequireAuth>
            <DashboardV3 />
          </RequireAuth>
        }
      />
    </Routes>
  );
}
